<template>
    <div class="video">
        <button
            type="button"
            class="video-thumb relative block w-full h-auto aspect-video overflow-hidden border-0 cursor-pointer"
            @click="open"
            :aria-label="`Play ${title || 'video'}`"
        >
            <img
                class="h-full w-full object-cover object-center"
                :src="thumbnail"
                :alt="title || 'Video thumbnail'"
            />
            <span
                class="video-thumb__overlay absolute inset-0 flex items-center justify-center transition"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="120"
                    height="120"
                    viewBox="0 0 24 24"
                >
                    <path
                        fill="#ffffff"
                        d="M10 15.577L15.577 12L10 8.423zM12.003 21q-1.866 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
                    />
                </svg>
            </span>
        </button>
        <p v-if="title" class="text-white text-lg mt-2" v-html="title"></p>

        <transition name="fade">
            <div
                v-if="isOpen"
                class="video-modal fixed inset-0 z-50 flex items-center justify-center p-4"
                @click.self="close"
                role="dialog"
                aria-modal="true"
            >
                <div class="video-modal__body relative w-full max-w-4xl">
                    <div
                        class="video-modal__header flex items-center justify-between px-4 py-3"
                    >
                        <h3
                            class="video-modal__title text-white text-lg"
                            v-html="title || 'Video'"
                        ></h3>
                        <button
                            type="button"
                            class="video-modal__close text-white text-3xl border-0 cursor-pointer"
                            @click="close"
                            aria-label="Close video"
                        >
                            &times;
                        </button>
                    </div>
                    <div
                        v-if="is_embed"
                        class="video-modal__embed w-full aspect-video bg-black shadow-lg"
                        v-html="src"
                    ></div>
                    <video
                        v-else
                        ref="player"
                        :src="src"
                        :poster="thumbnail"
                        type="video/mp4"
                        class="w-full h-auto bg-black shadow-lg"
                        controls
                        autoplay
                    ></video>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "VideoItem",
    props: {
        title: {
            type: String,
            default: "",
        },
        src: {
            type: String,
            required: true,
            default: "#",
        },
        thumbnail: {
            type: String,
            required: true,
            default: "#",
        },
        is_embed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        open() {
            this.isOpen = true;
            document.body.style.overflow = "hidden";
            if (this.is_embed) return;
            this.$nextTick(() => {
                if (this.$refs.player) {
                    this.$refs.player.play().catch(() => {});
                }
            });
        },
        close() {
            if (!this.is_embed && this.$refs.player) {
                this.$refs.player.pause();
                this.$refs.player.currentTime = 0;
            }
            this.isOpen = false;
            document.body.style.overflow = "";
        },
        onKeydown(e) {
            if (e.key === "Escape" && this.isOpen) {
                this.close();
            }
        },
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.onKeydown);
        document.body.style.overflow = "";
    },
};
</script>

<style scoped lang="scss">
.video-thumb {
    background: #000;
    padding: 0;

    &:focus,
    &:focus-visible {
        outline: 2px solid rgba(255, 255, 255, 0.6);
        outline-offset: 2px;
    }

    &__overlay {
        background-color: rgba(0, 0, 0, 0.3);
    }

    &:hover .video-thumb__overlay,
    &:focus .video-thumb__overlay {
        background-color: rgba(0, 0, 0, 0.5);
    }
}

.video-modal {
    background-color: rgba(0, 0, 0, 0.8);

    &__body {
        background: #111;
        border-radius: 0.375rem;
        overflow: hidden;
    }

    &__header {
        background: #000;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    &__title {
        margin: 0;
        line-height: 1.2;
        font-weight: 600;
    }

    &__close {
        background: transparent;
        line-height: 1;
        padding: 0 0.25rem;

        &:hover {
            opacity: 0.75;
        }
    }

    &__embed {
        position: relative;

        ::v-deep iframe {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
